import React, { useState } from "react";
import { format } from "date-fns";
import Grid from "@mui/material/Unstable_Grid2";
import { Box, Button, Typography, MenuItem, Menu } from "@mui/material";
import { styled, alpha } from "@mui/material/styles";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import TimeToLeaveIcon from "@mui/icons-material/TimeToLeave";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { uniqueString } from "../../utils";

import { config, styles } from "../../style";
import { CalendarTodayOutlined } from "@mui/icons-material";
import LocationCard from "./ActivityDataCards/LocationCard";
import FlightCard from "./ActivityDataCards/FlightCard";
import GroundCard from "./ActivityDataCards/GroundCard";
import PrivateFlightCard from "./ActivityDataCards/PrivateFlightCard";
import RailCard from "./ActivityDataCards/RailCard";
import EventActivityCard from "./ActivityDataCards/EventActivityCard";

const StyledMenu = styled((props) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
        }}
        transformOrigin={{
            vertical: "top",
            horizontal: "right",
        }}
        {...props}
    />
))(({ theme }) => ({
    "& .MuiPaper-root": {
        borderRadius: 6,
        marginTop: theme.spacing(1),
        minWidth: 180,
        color: theme.palette.mode === "light" ? "rgb(55, 65, 81)" : theme.palette.grey[300],
        boxShadow:
            "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
        "& .MuiMenu-list": {
            padding: "4px 0",
        },
        "& .MuiMenuItem-root": {
            "& .MuiSvgIcon-root": {
                fontSize: 18,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1.5),
            },
            "&:active": {
                backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            },
        },
    },
}));

export const Itinerary = (props) => {
    const { recordId, activities, shared, recordName, handlePopoverComment, prepareDocumentData } = props;

    const [activityAnchorEl, setActivityAnchorEl] = useState(null);
    const activityFilterOpen = Boolean(activityAnchorEl);
    const [dayAnchorEl, setDayAnchorEl] = useState(null);
    const [selectedActivityFilter, setSelectedActivityFilter] = useState(null);
    const [selectedDayFilter, setSelectedDayFilter] = useState(null);
    const dayFilterOpen = Boolean(dayAnchorEl);

    const handleActivityFilterClick = (event) => {
        setActivityAnchorEl(event.currentTarget);
    };
    const handleActivityFilterClose = () => {
        setActivityAnchorEl(null);
    };
    const handleDayFilterClick = (event) => {
        setDayAnchorEl(event.currentTarget);
    };
    const handleDayFilterClose = () => {
        setDayAnchorEl(null);
    };

    const getActivities = () => {
        let displayActivity = [...activities];

        if (selectedActivityFilter) {
            displayActivity = [...displayActivity.filter((item) => item.recordTypeName === selectedActivityFilter)];
        }

        if (selectedDayFilter) {
            displayActivity = [
                ...displayActivity.filter(
                    (item) => item.departureStartDateString && item.departureStartDateString === selectedDayFilter
                ),
            ];
        }

        // adding dummy data
        displayActivity = displayActivity?.map((cItem, index) => {
            return cItem;
        });

        const groupedDisplayActivity = Object.values(
            displayActivity?.reduce((acc, obj) => {
                let date = obj.departureStartDateString;
                if (!acc[date]) {
                    acc[date] = { departureStart: obj.departureStartDateString, items: [] };
                }
                acc[date].items.push(obj);
                return acc;
            }, {})
        );
        // console.log("displayActivity, groupedDisplayActivity...", displayActivity, groupedDisplayActivity);

        return groupedDisplayActivity;
    };

    const getActivityFilterMenu = () => {
        let filters = {};

        for (let activity of activities) {
            filters[activity.recordTypeName] = activity;
        }

        return [
            { label: "All", value: "", id: uniqueString(10) },
            ...Object.keys(filters).map((item) => {
                return { label: item, value: item, id: uniqueString(10) };
            }),
        ];
    };

    const getDayFilterMenu = () => {
        let filters = {};

        for (let activity of activities) {
            const dateValue = activity.departureStartDateString;
            filters[dateValue] = activity;
        }

        return [
            { label: "All", value: "", id: uniqueString(10) },
            ...Object.keys(filters).map((item) => {
                return { label: item, value: item, id: uniqueString(10) };
            }),
        ];
    };

    const handleActivitySelect = (value) => {
        setSelectedActivityFilter(value);
        handleActivityFilterClose();
    };

    const handleDaySelect = (value) => {
        setSelectedDayFilter(value);
        handleDayFilterClose();
    };

    const handleOpenComment = (subject) => {
        // const event = new CustomEvent("openDrawer", {
        //     detail: { parentId: recordId, subject: subject, parentName: recordName, type: "popover" },
        // });
        // document.dispatchEvent(event);

        handlePopoverComment("", subject);
    };

    return (
        <>
            <Grid container spacing={0.5}>
                <Grid
                    item
                    display={{ xs: "flex", sm: "block" }}
                    width={{ xs: "100%", sm: "unset" }}
                    alignItems={"center"}
                    sx={(theme) => ({
                        "@media (max-width:375px)": {
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "start",

                            "&>*": {
                                width: "100%",
                            },
                        },
                    })}>
                    <Typography
                        component={"span"}
                        variant="paraText6"
                        color={"#7E7E7E"}
                        fontWeight={"fontWeightMedium"}>
                        Filter By:
                    </Typography>
                    <Button
                        id="activity-filter-button"
                        aria-controls={activityFilterOpen ? "activity-filter-menu" : undefined}
                        aria-haspopup="true"
                        aria-expanded={activityFilterOpen ? "true" : undefined}
                        variant="outlined"
                        disableElevation
                        onClick={handleActivityFilterClick}
                        endIcon={<KeyboardArrowDownIcon sx={{ color: "#0084D4" || config.primaryColor }} />}
                        startIcon={<TimeToLeaveIcon sx={{ color: "#0084D4" || config.primaryColor }} />}
                        sx={{
                            ...styles.outlinedButton,
                            marginLeft: { xs: "0.5rem", sm: "1rem" },

                            "@media (max-width:375px)": {
                                marginLeft: "0",
                                marginTop: "0.5rem",
                            },
                        }}>
                        Activities {selectedActivityFilter && <span>: {selectedActivityFilter}</span>}
                    </Button>
                    <StyledMenu
                        id="activity-filter-menu"
                        MenuListProps={{
                            "aria-labelledby": "activity-filter-button",
                        }}
                        anchorEl={activityAnchorEl}
                        open={activityFilterOpen}
                        onClose={handleActivityFilterClose}>
                        {getActivityFilterMenu().map((item) => (
                            <MenuItem key={item.id} onClick={() => handleActivitySelect(item.value)} disableRipple>
                                {item.label}
                            </MenuItem>
                        ))}
                    </StyledMenu>
                    <Button
                        id="day-filter-button"
                        aria-controls={dayFilterOpen ? "day-filter-menu" : undefined}
                        aria-haspopup="true"
                        aria-expanded={dayFilterOpen ? "true" : undefined}
                        variant="outlined"
                        disableElevation
                        onClick={handleDayFilterClick}
                        endIcon={<KeyboardArrowDownIcon sx={{ color: "#0084D4" || config.primaryColor }} />}
                        startIcon={<CalendarMonthIcon sx={{ color: "#0084D4" || config.primaryColor }} />}
                        sx={{
                            ...styles.outlinedButton,
                            marginLeft: { xs: "0.5rem", sm: "1rem" },

                            "@media (max-width:375px)": {
                                marginLeft: "0",
                                marginTop: "0.5rem",
                            },
                        }}>
                        Day {selectedDayFilter && <span>: {selectedDayFilter}</span>}
                    </Button>
                    <StyledMenu
                        id="day-filter-menu"
                        MenuListProps={{
                            "aria-labelledby": "day-filter-button",
                        }}
                        anchorEl={dayAnchorEl}
                        open={dayFilterOpen}
                        onClose={handleDayFilterClose}>
                        {getDayFilterMenu().map((item) => (
                            <MenuItem key={item.id} onClick={() => handleDaySelect(item.value)} disableRipple>
                                {item.label}
                            </MenuItem>
                        ))}
                    </StyledMenu>
                </Grid>

                {!shared && (
                    <Grid
                        item
                        xsOffset="auto"
                        width={{
                            xs: "100%",
                            sm: "auto",
                        }}
                        display={"flex"}
                        justifyContent={{
                            xs: "end",
                        }}>
                        <Button
                            id="change-schedule"
                            onClick={() => handleOpenComment("Request a schedule change")}
                            sx={{
                                ...styles.outlinedButton,
                                width: "auto",
                                marginTop: {
                                    xs: "0.5rem",
                                    sm: "unset",
                                },

                                "@media (max-width:375px)": {
                                    marginLeft: "0",
                                    width: "100%",
                                    marginTop: "0.5rem",
                                },
                            }}
                            startIcon={<AddCircleOutlineIcon fontSize="small" sx={{ color: config.primaryColor }} />}
                            variant="outlined">
                            Request a schedule change
                        </Button>
                    </Grid>
                )}
            </Grid>

            {getActivities().map((cItem) => (
                <div>
                    <Box
                        padding={"12px 16px"}
                        display={"flex"}
                        alignItems={"center"}
                        marginTop={"1rem"}
                        sx={{
                            borderRadius: "10px",
                            border: "1px solid #EEF4FF",
                            background: "#F5F8FF",
                        }}>
                        <CalendarTodayOutlined
                            fontSize="small"
                            sx={{
                                color: "#2B46A7",
                                width: "15px",
                                mt: "-1px",
                                mr: "6px",
                            }}></CalendarTodayOutlined>
                        <Typography component={"p"} color={"#2B46A7"} fontWeight={700}>
                            {cItem.departureStart}
                        </Typography>
                    </Box>

                    {cItem.items?.map((item) => (
                        <>
                            {item.recordTypeName === "Location" && (
                                <LocationCard item={item} prepareDocumentData={prepareDocumentData} />
                            )}
                            {item.recordTypeName === "Flight" && (
                                <FlightCard item={item} prepareDocumentData={prepareDocumentData} />
                            )}
                            {item.recordTypeName === "Ground" && (
                                <GroundCard item={item} prepareDocumentData={prepareDocumentData} />
                            )}
                            {item.recordTypeName === "Private Flight" && (
                                <PrivateFlightCard item={item} prepareDocumentData={prepareDocumentData} />
                            )}
                            {item.recordTypeName === "Rail" && (
                                <RailCard item={item} prepareDocumentData={prepareDocumentData} />
                            )}
                            {item.recordTypeName === "Event Activity" && (
                                <EventActivityCard item={item} prepareDocumentData={prepareDocumentData} />
                            )}
                        </>
                    ))}
                </div>
            ))}
        </>
    );
};
